import moment from 'moment';
import { http } from '../../../../common/http/client';
import type { Customer, Company } from './kycc';
import { Target } from './kycc';

export function checkCustomer(
  target: number,
  customer: Customer,
): Promise<Customer> {
  const data = new FormData();

  customer.conditions.forEach((condition, i) => {
    if (condition.name != null) {
      data.append(
        `company_kycc_customer${
          target === Target.oversea ? '_oversea' : ''
        }[conditions_attributes][${i}][name]`,
        condition.name,
      );
    }

    if (condition.birthday != null && condition.birthday !== '') {
      data.append(
        `company_kycc_customer${
          target === Target.oversea ? '_oversea' : ''
        }[conditions_attributes][${i}][birthday]`,
        moment(condition.birthday).format('YYYY-MM-DD'),
      );
    }
  });

  return http.post<Customer>(
    `/api/v1/my/company/kycc/customer${
      target === Target.oversea ? '_oversea' : ''
    }.json`,
    { body: data },
  );
}

export function checkCompany(
  target: number,
  company: Company,
): Promise<Company> {
  const data = new FormData();
  company.conditions.forEach((condition, i) => {
    if (condition.name != null) {
      data.append(
        `company_kycc_company${
          target === Target.oversea ? '_oversea' : ''
        }[conditions_attributes][${i}][name]`,
        condition.name,
      );
    }
  });

  return http.post<Company>(
    `/api/v1/my/company/kycc/company${
      target === Target.oversea ? '_oversea' : ''
    }.json`,
    { body: data },
  );
}
